module.exports = __webpack_public_path__ + "static/media/shopping_cart_checkout.abfa5e14.svg";